import Vue from 'vue'
import Vuex from 'vuex'
// import TemplateModule from './modules/__moduleTemplate/TemplateModule'
import SnackbarModalModule from './modules/SnackbarModal/SnackbarModalModule'
import sidebar from './modules/sidebar'
import AuthModule from './modules/Auth/AuthModule'
import MenuesModule from './modules/Menues/MenuesModule'
import WholesaleDiscountModule from './modules/WholesaleDiscount/WholesaleDiscountModule'
import EmployeeModule from './modules/Employee/EmployeeModule'
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        //TemplateModule
        SnackbarModalModule,
        AuthModule,
        sidebar,
        MenuesModule,
        WholesaleDiscountModule,
        EmployeeModule,
    },
    state: {},
    actions: {},
    getters: {},
})
